<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <loader v-show="loading" />
        <c-card-header>
          <c-card-title>
            <strong>Informasi Customer</strong>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered table-striped">
              <thead>
                <tr>
                  <th rowspan="2">No</th>
                  <th rowspan="2">Nama</th>
                  <th colspan="2">Pelanggan</th>
                  <th rowspan="2">Alamat</th>
                  <th rowspan="2">No Telepon</th>
                  <th rowspan="2">Perusahaan</th>
                  <th rowspan="2">Email</th>
                </tr>
                <tr>
                  <th>Kode</th>
                  <th>Tipe</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in report.data" :key="k">
                  <td>
                    <table-number :index="k" :paginate="report.paginate" />
                  </td>
                  <td>{{ v.name }}</td>
                  <td>{{ v.customer_id }}</td>
                  <td>{{ v.customer_type }}</td>
                  <td>{{ v.address }}</td>
                  <td>{{ v.phone }}</td>
                  <td>{{ v.email }}</td>
                  <td>{{ v.perusahaan }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-primary">
            <i class="cil-print"></i> Print</button>&nbsp;
          <button class="btn btn-success" @click="exportExcel">
            <i class="cil-cloud-download"></i>
            Excel
          </button>
          <paginator :paginator="report.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber2";
import Loader from '../../components/Loader.vue';
import { showErrorMessage } from '../../lib/helpers';
import Paginator from '../../components/Paginator.vue';
export default {
  data () {
    return {
      loading: true,
      report: {},
      currentPage: 1,
      total: 0,
      perPage: 10,
    };
  },
  components: {
    TableNumber,
    Loader,
    Paginator,
  },
  created () {
    this.getList(1, "");
  },
  methods: {
    getList (page, q) {
      this.loading = true
      HTTPAUTH.get(
        `/api/v1/report-master/customer?page=${page}&size=${this.perPage}&q=${q}`
      ).then((res) => {
        this.report = res.data;
        this.currentPage = page;
        this.total = this.report.paginate.total;
        this.$router.push({ query: { q: q, page: page } });
        this.loading = false
      }).catch(eres => {
        this.loading = false
        showErrorMessage(eres)
      });
    },
    async exportExcel () {
      this.loading = true
      let data = null;
      await HTTPAUTH.get(`/api/v1/report-master/customer/export`).then((res) => {
        data = res.data.data
      }).catch(() => {
        this.loading = false
      });
      await HTTPExport.post(`/api/v1/master/customer`, data).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      }).catch(() => {
        this.loading = false
      })
      this.loading = false
    },
    changePage (page) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(page, q);
    }
  },
};
</script>